(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-hero"] && !Shopify.designMode) return;
  try {
    
  const faqItems = Array.from(document.querySelectorAll('.b2b-hero__item'));
  for (const item of faqItems) {
    const onClick = () => {
      item.classList.toggle('active');
    };
    item.addEventListener('click', onClick);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-6-products"] && !Shopify.designMode) return;
  try {
    
  // clears progress bar on first load - may get updated again from updateDiscountsSection()
// $(".progress-bar-inner").html('');

  $(document).ready(function() {
    var params = new URLSearchParams(window.location.search);
    var urlId = params.get('prid');

    if (urlId) {
      document.querySelectorAll('.tab-content').forEach((item) => {
        item.classList.remove('current');
      });

      document.querySelectorAll('.tab-link').forEach((item) => {
        item.classList.remove('current');
      });

      const activeTabContent = document.querySelector(`[data-url-id="${urlId}"]`);
      activeTabContent.classList.add('current');

      const activeTab = document.querySelector(`[data-tab="${
        activeTabContent.id
      }"]`);
      activeTab.classList.add('current');
    }
  });


/* * * * * * * * * *
   * HELPER FUNCTIONS *
   * * * *  * * * * * */

  /*
   * Each option is rendered as its own list straight from options_with_values, so colour and size are offered
   * independently of one another and pairings with no variant behind them could be selected - Split King only
   * exists in White, yet every colour was on offer against it.
   *
   * That was not only cosmetic. Variants._onSelectChange in product.js returns before updating the hidden id when
   * no variant matches the selection, and this handler used to re-enable the button unconditionally and then only
   * check that an id was present at all. The id still held the previously selected variant, so the shopper saw a
   * live ADD TO CART and the item that reached the cart was not the one on screen.
   *
   * These helpers resolve the real variant for the current selection out of the product JSON the snippet already
   * prints, and drive which values stay selectable, the hidden id, and the button from it.
   */

  function getProductData(productForm) {
    var container = productForm.closest('[data-section-type="product"]');
    var node = container && container.querySelector('[data-product-json]');

    if (!node) {
      return null;
    }

    if (node._parsedProduct === undefined) {
      try {
        node._parsedProduct = JSON.parse(node.textContent);
      } catch (error) {
        node._parsedProduct = null;
      }
    }

    return node._parsedProduct && node._parsedProduct.variants ? node._parsedProduct : null;
  }

  function getOptionSelectors(productForm) {
    return Array.prototype.slice.call(productForm.querySelectorAll('[data-single-option-selector]'));
  }

  function findVariant(product, selectors) {
    if (!product) {
      return null;
    }

    // With no selectors (a single-variant product) every variant trivially matches, which is the right answer.
    return product.variants.filter(function (variant) {
      return selectors.every(function (selector) {
        return variant[selector.dataset.index] === selector.value;
      });
    })[0] || null;
  }

  // Colour is presented as swatches with the select behind it hidden, so a programmatic change has to be mirrored
  // onto the visible summary the way Swatches.updateSwatches does, minus the change event it re-dispatches.
  function syncColorSummary(selector) {
    var listItem = selector.closest('.list__item--color');
    var summary = listItem && listItem.querySelector('.color_select');

    if (!summary) {
      return;
    }

    Array.prototype.forEach.call(listItem.querySelectorAll('.colors__item'), function (item) {
      var swatch = item.querySelector('.color__swatch');

      if (swatch && swatch.dataset.color === selector.value) {
        summary.innerHTML = item.innerHTML;
      }
    });
  }

  // Leave only the values that still have a variant behind them given what is selected on the other options, so an
  // impossible pairing cannot be built in the first place. Sizes are disabled in place to keep the dropdown stable;
  // colour swatches are hidden, since a greyed-out swatch reads as a colour that exists but is out of stock.
  function updateOptionAvailability(productForm) {
    var product = getProductData(productForm);

    if (!product) {
      return;
    }

    var selectors = getOptionSelectors(productForm);

    selectors.forEach(function (selector) {
      var index = selector.dataset.index;
      var others = selectors.filter(function (other) { return other !== selector; });
      var available = product.variants
        .filter(function (variant) {
          return others.every(function (other) { return variant[other.dataset.index] === other.value; });
        })
        .map(function (variant) { return variant[index]; });

      // Values with no variant behind them are dimmed rather than removed, so the shopper still sees the full
      // range on offer and can tell the value is out of reach for this selection rather than watching it vanish.
      var reason = 'Not available with ' + others.map(function (other) { return other.value; }).join(' / ');

      Array.prototype.forEach.call(selector.options, function (option) {
        var unavailable = available.indexOf(option.value) === -1;

        option.disabled = unavailable;

        if (unavailable) {
          option.title = reason;
        } else {
          option.removeAttribute('title');
        }
      });

      var listItem = selector.closest('.list__item');

      if (!listItem) {
        return;
      }

      Array.prototype.forEach.call(listItem.querySelectorAll('.colors__item'), function (item) {
        var swatch = item.querySelector('.color__swatch');
        var value = swatch && swatch.dataset.color;
        var unavailable = available.indexOf(value) === -1;

        item.classList.toggle('is-unavailable', unavailable);
        item.setAttribute('aria-disabled', unavailable ? 'true' : 'false');

        if (unavailable) {
          item.title = reason;
        } else {
          item.removeAttribute('title');
        }

        // pointer-events keeps the mouse out, but the anchor is still tabbable without this.
        if (swatch) {
          if (unavailable) {
            swatch.setAttribute('tabindex', '-1');
          } else {
            swatch.removeAttribute('tabindex');
          }
        }
      });
    });
  }

  // Recover from a change that strands the rest of the form on a combination that does not exist: keep the value
  // the shopper just touched and move the others onto the first variant that honours it, preferring one in stock.
  function reconcileSelection(productForm, changedSelector) {
    var product = getProductData(productForm);
    var selectors = getOptionSelectors(productForm);

    if (!product || findVariant(product, selectors)) {
      return;
    }

    var pinned = changedSelector || selectors[0];

    if (!pinned) {
      return;
    }

    var candidates = product.variants.filter(function (variant) {
      return variant[pinned.dataset.index] === pinned.value;
    });
    var fallback = candidates.filter(function (variant) { return variant.available; })[0] || candidates[0];

    if (!fallback) {
      return;
    }

    selectors.forEach(function (selector) {
      if (selector === pinned || selector.value === fallback[selector.dataset.index]) {
        return;
      }

      selector.value = fallback[selector.dataset.index];
      syncColorSummary(selector);
    });
  }

  // Clearing the hidden id when nothing matches means a form in an impossible state posts no variant at all rather
  // than the last good one, so a stale selection cannot survive even if the button is re-enabled by something else.
  function syncMasterSelect(productForm, variant) {
    var master = productForm.querySelector('[data-product-select]');

    if (!master) {
      return;
    }

    if (variant) {
      master.value = String(variant.id);
    } else {
      master.selectedIndex = -1;
    }
  }

  function updateAddButton(productForm, variant) {
    var addToCart = productForm.querySelector('.btn--add-item');

    if (!addToCart) {
      return;
    }

    if (!variant) {
      addToCart.disabled = true;
      addToCart.innerHTML = 'UNAVAILABLE';
    } else if (!variant.available) {
      addToCart.disabled = true;
      addToCart.innerHTML = 'SOLD OUT';
    } else {
      addToCart.disabled = false;
      addToCart.innerHTML = 'ADD TO CART';
    }
  }

  function refreshProductForm(productForm, changedSelector) {
    if (!productForm) {
      return;
    }

    var addToCart = productForm.querySelector('.btn--add-item');

    // Without the product JSON there is nothing to validate against, so fall back to the original behaviour rather
    // than disabling a button that is probably fine.
    if (!getProductData(productForm)) {
      if (addToCart) {
        var hasId = new URLSearchParams($(productForm).serialize()).has('id');

        addToCart.disabled = !hasId;
        addToCart.innerHTML = hasId ? 'ADD TO CART' : 'SOLD OUT';
      }

      return;
    }

    reconcileSelection(productForm, changedSelector);
    updateOptionAvailability(productForm);

    var variant = findVariant(getProductData(productForm), getOptionSelectors(productForm));

    syncMasterSelect(productForm, variant);
    updateAddButton(productForm, variant);
  }

  function serializeEventData(event) {
    var productForm = event.target.closest('form');

    if (!productForm) {
      return;
    }

    // Swatch clicks land on the anchor rather than the select, so fall back to the selector in the same option row.
    var listItem = event.target.closest('.list__item');
    var changedSelector = event.target.closest('[data-single-option-selector]')
      || (listItem && listItem.querySelector('[data-single-option-selector]'));

    refreshProductForm(productForm, changedSelector);
  }

  function updateCartCountInHeader(cart) {
    let cartCount = $('.cartcount');
    cartCount.html(cart.item_count);
  }


/* * * * * * * * **
   * MAIN TAB CHANGE *
   * * * * * * * * * */
  $('ul.tabs li').click(function() {
    var tab_id = $(this).attr('data-tab');
    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');

    var itemNumber = parseInt(tab_id.split('-')[1]);
    var productContainer = $('[data-item-number="' + itemNumber + '"]');
    const productForm = productContainer.find('.product__form');
    refreshProductForm(productForm[0]);

    $(this).addClass('current');
    $('#' + tab_id).addClass('current');

// Reset product images slider after switching a tab
    let productSlider = $('#' + tab_id).find('.product__images-slider');
    if (productSlider.length) {
      productSlider.slick('setPosition');
    }
    document.querySelector(`#${tab_id}`) ?. querySelector('.form__list li .color_swatch li .color__swatch') ?. classList.add('active');
  });


/* * * * * * * * *
   * GO BACK BUTTON *
   * * * * * * * * **/
  $('.btn--bundle-prev').click(function(e) {
    e.preventDefault();
    const productContainer = $(this).closest('.tab-content');
    const itemNumber = parseInt(productContainer.data('item-number')) - 1;
    const prevTabLink = $('.tab-link-' + itemNumber);
    prevTabLink.click();
  });


/* * * * * * * * * * *
   * FORMS AND COLOURS *
   * * * * * * * * * * */

  /*
   * These are bound through jQuery, delegated on document, and both details matter.
   *
   * Swatches.updateSwatches in product.js changes the colour with .val().trigger('change'). A jQuery-triggered
   * event is only propagated to jQuery handlers - it is never dispatched to the DOM - so a native
   * addEventListener on the form does not see it. Picking a colour therefore left the size list filtered against
   * the previous colour, which is how Split King stayed on offer after switching to Navy.
   *
   * Delegating on document also fixes the ordering: this now runs after Variants (bound on the select itself) and
   * after Swatches (delegated on body), so the selection has settled by the time we read it.
   */
  $(document).on('change', '.product__form [data-single-option-selector]', function (event) {
    serializeEventData(event);
  });

  // Safety net for the swatch path, in case the colour select is not updated for some reason. Also delegated on
  // document so it lands after Swatches rather than before it, and idempotent with the change handler above.
  $(document).on('click', '.product__form .colors__item', function (event) {
    serializeEventData(event);
  });

  // Settle each form up front: Liquid selects the first colour and first size independently of the variant the
  // hidden id was rendered with, so the two can disagree before the shopper touches anything.
  $(function () {
    $('.product__form').each(function () {
      refreshProductForm(this);
    });
  });


/* * * * * * * * * * * **
   * CUSTOM COLOR SELECTOR *
   * * * * * * * * * * * * */
  $(document).click(function() {
    $('.bundle__builder .color__colors').hide();
  });

  $('.bundle__builder .color_select').click(function(e) {
    e.stopPropagation();
    $(this).next('.color__colors').toggle();
  });

  $('.bundle__builder .color__swatch-title').click(function() {
    $(this).siblings('.color__swatch').click();
  });

  $('.bundle__builder .colors__item').click(function() {
    const item = $(this).html();
    $(this).closest('.list__item').find('.color_select').html(item);
  });


/* * * * * *
   * ADD ITEM *
   * * * * * **/
// $('.btn--add-item').click(function (e) {
// e.preventDefault();
// const $this = $(this);
// const productContainer = $this.closest('.tab-content');
// const productForm = productContainer.find('.product__form');
// const itemNumber = productContainer.data('item-number');
// const productImage = productContainer.find('.product__images .images__featured').eq(1);
// const summaryItem = $('.bundle-item-' + itemNumber);
// const tabLink = $('.tab-link-' + itemNumber);

// $.ajax({
// url: '/cart/add.js',
// dataType: 'json',
// cache: false,
// type: 'post',
// data: productForm.serialize(),
// beforeSend: function beforeSend() {
// $this.find('[data-add-to-cart-text]').text('Adding...');
// },
// success: function success(product) {
// // avoid cart popup
// var removeCartVisible = setInterval(function () {
// if ($('#rebuy-cart.is-visible').length > 0) {
// clearInterval(removeCartVisible);
// Rebuy.SmartCart.hide();
// }
// }, 100);
// // empty slot
// if (!summaryItem.hasClass('has-item')) {
// summaryItem.addClass('has-item');
// // mobile quantity
// tabLink.addClass('has-item');
// }

// let currentQuantity = parseInt(tabLink.attr('data-quantity'));
// let quantityAdded = parseInt(productForm.find('input[name="quantity"]').val());
// summaryItem.find('.bundle-item-image-quantity').html(currentQuantity + quantityAdded);
// summaryItem.find('.bundle-item-image-container').append(productImage.clone());
// // mobile quantity
// tabLink.attr('data-quantity', currentQuantity + quantityAdded);

// let currentProducts = summaryItem.attr('data-items');
// let newProduct = product.id + ',' + quantityAdded;
// let newValue = currentProducts ? currentProducts + ';' + newProduct : newProduct;
// summaryItem.attr('data-items', newValue);

// // ATC button
// $this.find('[data-add-to-cart-text]').text('Added!');

// setTimeout(function () {
// $this.find('[data-add-to-cart-text]').text('ADD ANOTHER');
// $this.addClass('btn--border');
// const prodContainer = $this.closest('.tab-content');
// const itemNumber = parseInt(prodContainer.data('item-number')) + 1;
// const nextTabLink = $('.tab-link-' + itemNumber);
// nextTabLink.click();
// }, 2000);

// jQuery.getJSON('/cart.js', function (cart) {
// shippingModal(cart);
// updateDiscountsSection(cart);
// updateFreeShippingNote(cart);
// updateCartCountInHeader(cart);

// if (window.matchMedia('(max-width: 767px)').matches) {
// modalSetup.showModal();
// modalSetup.init();
// }
// });
// },
// error: function error(XMLHttpRequest) {
// $this.html('SOLD OUT');
// var response = eval('(' + XMLHttpRequest.responseText + ')');
// },
// });
// });

// /* * * * * * **
// * REMOVE ITEM *
// * * * * * * * */
// $('.bundle-item-image-remove').click(function () {
// let summaryItem = $(this).closest('.bundle-item');
// let items = summaryItem.attr('data-items').split(';');
// let item = items.pop();
// let itemID = item.split(',')[0];
// let itemQuantity = item.split(',')[1];

// const itemNumber = summaryItem.data('item-number');
// const tabLink = $('.tab-link-' + itemNumber);

// $.ajax({
// type: 'POST',
// url: '/cart/change.js',
// data: 'quantity=0&id=' + itemID,
// dataType: 'json',
// success: function success(cart) {
// // avoid cart popup
// var removeCartVisible = setInterval(function () {
// if ($('#rebuy-cart.is-visible').length > 0) {
// clearInterval(removeCartVisible);
// Rebuy.SmartCart.hide();
// }
// }, 100);

// summaryItem.find('.bundle-item-image-container img').last().remove();
// // check if not the last product
// if (items.length) {
// summaryItem.attr('data-items', items.join(';'));
// } else {
// summaryItem.removeClass('has-item').attr('data-items', '');
// tabLink.removeClass('has-item');
// }

// let currentQuantity = parseInt(tabLink.attr('data-quantity'));
// summaryItem.find('.bundle-item-image-quantity').html(currentQuantity - itemQuantity);
// // mobile quantity
// tabLink.attr('data-quantity', currentQuantity - itemQuantity);

// updateDiscountsSection(cart);
// updateFreeShippingNote(cart);
// updateCartCountInHeader(cart);
// },
// error: function error(XMLHttpRequest) {
// console.error(XMLHttpRequest);
// },
// });
// });


/* * * * * **
   * SHOW CART *
   * * * * * * */
// if (window.matchMedia('(max-width: 767px)').matches) {
// $('.bundle__builder-checkout a').attr('href', '/cart');
// }


/* * * * * * * *
   * CHANGE COUNT *
   * * * * * * * **/
// var xhttp = new XMLHttpRequest();
// var cur = '';
// xhttp.onreadystatechange = function() {
// if (this.readyState == 4 && this.status == 200) {
// var res = JSON.parse(xhttp.responseText);

// if (res.detected_values.country_name == 'Canada') {
// cur = 'CAD';
// } else {
// cur = 'USD';
// }

// var count = 1;
// var tab_count = 0;
// if (tab_count <= 3) {
// count++;
// var tabs = document.querySelectorAll('.tab-link');

// tabs.forEach(function(tab) {
// var current_tab = tab.dataset.tab;
// var tab_id = '#' + current_tab;
// var sp = $(tab_id).find('sale-price');
// var p = "";
// if (tab_id == '#tab-2') {
// p = "$105 " + cur;
// sp.html(p).attr('data-sale-price', p);
// }
// if (tab_id == '#tab-3') {
// p = "$140 " + cur;
// sp.html(p).attr('data-sale-price', p);
// }
// });
// }
// }
// };
// xhttp.open("GET", "/browsing_context_suggestions.json", true);
// xhttp.send();

// document.querySelectorAll('.tabs li').forEach(li=>li.addEventListener('click', function () {

// const tab_id = li.dataset.tab;
// document.querySelector(`#${tab_id}`)?.querySelector('.form__list li .color_swatch li .color__swatch')?.classList.add('active');
// }))

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function loadBadge() {
    const imageSrc = 'https://benjilinens.myshopify.com/cdn/shop/t/231/assets/product-badge.png';

    const el = document.createElement('img');
    el.classList.add('product-badge-ca');
    el.src = imageSrc;

    const heroImage = document.getElementById('pwzrswiper-slide-0');
    heroImage.insertAdjacentElement('beforeend', el);
  }

  function debounce(func, time) {
    var time = time || 100; // 100 by default if no param
    var timer;
    return function (event) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(func, time, event);
    };
  }

  function handleWindowResizeForBadge() {
    document.querySelector('.product-badge-ca')?.remove();
    loadBadge();
  }

  document.addEventListener('DOMContentLoaded', () => {
    const pathname = window.location.pathname;
    const pathnamesToLoadBadge = [
      '/products/sheet-sets',
      '/products/duvet-sets',
      '/products/comforter',
      '/products/pillow-sets',
    ];

    if (pathnamesToLoadBadge.includes(pathname)) {
      loadBadge();
      window.addEventListener('resize', debounce(handleWindowResizeForBadge, 150));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-text"] && !Shopify.designMode) return;
  try {
    
  function togglePlayButton() {
    // Select all elements with the .cs-picture class
    const pictures = document.querySelectorAll('.cs-video-wrapper');

    // Add a click event listener to each .cs-picture element
    pictures.forEach((picture) => {
      picture.addEventListener('click', () => {
        // Select all elements with the .cs-play class
        const playButton = picture.querySelector('.cs-play');

        // Toggle the .cs-hide class on each .cs-play element
        playButton.classList.toggle('cs-hide');
      });
    });
  }

  // Call the function to activate the event listeners
  togglePlayButton();

  function toggleVideoPlayback() {
    // Select the video element
    const videos = document.querySelectorAll('.cs-video-wrapper video');

    // Add a click event listener to the video
    videos.forEach((video) => {
      video.addEventListener('click', () => {
        // Check if the video is paused
        if (video.paused) {
          video.play(); // Play the video if it is paused
        } else {
          video.pause(); // Pause the video if it is playing
        }
      });
    });
  }

  // Call the function to activate the event listener
  toggleVideoPlayback();

  } catch(e) { console.error(e); }
})();
})();
